import { render, staticRenderFns } from "./interDirectorInfo.vue?vue&type=template&id=15f9f9ae"
import script from "./interDirectorInfo.vue?vue&type=script&lang=js"
export * from "./interDirectorInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports